<template>
  <div>
    <content-placeholder v-if="fetching">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-card>
            <p class="text text-10 text-h-20"></p>
            <p class="text text-full"></p>
            <p class="text text-50"></p>
          </el-card>
        </el-col>
      </el-row>
    </content-placeholder>

    <div v-else>
      <page-heading :title="'PTO Request: (' + capitalize(pto.status) + ')'" :loading="fetching">
        <template slot="buttons">
          <router-link :to="{ name: 'ptos' }"><el-button type="info">Back to all PTOs</el-button></router-link>
        </template>
      </page-heading>

      <el-row :gutter="20">
        <el-col :span="12">

          <el-card v-loading="updating">
            <div slot="header">
              <span>{{ pto.category.name }}</span>
            </div>
            <table cellpadding="5" cellspacing="5">
              <tr>
                <td width="150px"><i class="global-icon fas fa-user"></i> Name</td>
                <td>{{ pto.user.profile.first_name }} {{ pto.user.profile.last_name }}</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon far fa-calendar"></i> Requested</td>
                <td>{{ pto.created_at | formatTime }}</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon fas fa-stopwatch"></i> Start Time</td>
                <td>{{ pto.starts_at | formatTime('MMMM DD, YYYY hh:mm a') }}</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon fas fa-stopwatch"></i> End Time</td>
                <td>{{ pto.ends_at | formatTime('MMMM DD, YYYY hh:mm a') }}</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon fas fa-calendar-day"></i> Duration</td>
                <td>{{ pto.requested_offdays }} day(s)</td>
              </tr>
              <tr>
                <td width="150px"><i class="global-icon fas fa-folder"></i> Type</td>
                <td>{{ pto.category.name }}</td>
              </tr>
            </table>

            <div slot="footer" v-if="this.currentUser.admin">
              <pto-status-buttons :pto="pto" :onStatusChange="handleOnStatusChange" />
            </div>

          </el-card>
        </el-col>
        <el-col :span="12">
          <comments-list ref="commentsList" :id="ptoId" :maxHeight="300" type="Pto" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  import CalendarService from '@/services/calendarService';
  import PtoStatusButtons from '@/components/pto/PtoStatusButtons';
  import CommentsList from '@/components/comment/CommentsList';

  export default {
    name: 'PtoPage',
    components: {
      ptoStatusButtons: PtoStatusButtons,
      commentsList: CommentsList,
    },
    created() {
      if (this.pto === null) {
        this.fetchSinglePto(this.ptoId);
      }
    },
    data() {
      return {
        translationPrefix: 'pages.pto',
        ptoId: parseInt(this.$router.currentRoute.params.id, 10),
      };
    },
    computed: {
      ...mapGetters('entities/users', ['currentUser']),
      ...mapGetters('entities/ptos', ['fetching']),

      pto() {
        return this.$store.getters['entities/ptos/query']()
          .with('user.profile')
          .with('category')
          .where('id', this.ptoId)
          .first();
      },

      updating() {
        return this.$store.getters['entities/ptos/isUpdating'](this.ptoId);
      },
    },
    methods: {
      ...mapActions('entities/ptos', ['fetchSinglePto']),

      handleOnStatusChange(response, data) {
        if (data.comments_attributes) {
          this.$refs.commentsList.fetchCommentsForCommentable();
        }
      },
      capitalize(s) {
        if (typeof s !== 'string') return '';
        return s.charAt(0).toUpperCase() + s.slice(1);
      },
      getDays(date1, date2) {
        return CalendarService.getDays(date1, date2);
      },
    },
  };
</script>

<style lang="scss" scoped>
  h2{
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Pto.vue